/**
 * Document Imports Feature Routes
 * Routes for the document import management page.
 */

import permissions from '@Share/config/permissions';

export default [
  {
    path: '/manage-document-imports',
    name: 'DocumentImportsAdmin',
    component: () => import('./views/DocumentImports.vue'),
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Documents Management',
      permissions: [permissions.Documents.Upload],
    },
  },
];
